import type { FeatureConfigMap } from '@luna/feature-config';

import type { InsuranceFeatureConfig } from '../types/InsuranceFeatureConfig';
import { insurances as base } from './base';
import { insurances as AT } from './AT';
import { insurances as CZ } from './CZ';
import { insurances as HR } from './HR';
import { insurances as HU } from './HU';
import { insurances as RO } from './RO';
import { insurances as RS } from './RS';
import { insurances as SK } from './SK';

export const featureConfigMap: FeatureConfigMap<InsuranceFeatureConfig> = {
    base,
    AT: AT as InsuranceFeatureConfig,
    CZ: CZ as InsuranceFeatureConfig,
    HR: HR as InsuranceFeatureConfig,
    HU: HU as InsuranceFeatureConfig,
    RO: RO as InsuranceFeatureConfig,
    RS: RS as InsuranceFeatureConfig,
    SK: SK as InsuranceFeatureConfig,
};
